import { ClientConfig } from "./ClientConfig";

export function createConfig(): ClientConfig {
  return {
    production: false,
  };
}
